import { render } from "./index.vue?vue&type=template&id=3c2e5854&ts=true"
import script from "./dropdown.ts?vue&type=script&lang=ts"
export * from "./dropdown.ts?vue&type=script&lang=ts"

import "./dropdown.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\Devin\\Desktop\\drawing app\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__